// Determine Delivery Day
  const deliveryData = [
    {
      "region": "Syd Metro",
      "postcodes": [
        "2000","2006","2007","2008","2009","2010","2011","2015","2016","2017","2018","2019",
        "2020","2021","2022","2023","2024","2025","2026","2027","2028","2029","2030","2031",
        "2032","2033","2034","2035","2036","2037","2038","2039","2040","2041","2042","2043",
        "2044","2045","2046","2047","2048","2049","2050","2052","2060","2061","2062","2063",
        "2064","2065","2066","2067","2068","2069","2070","2071","2072","2073","2074","2075",
        "2076","2084","2085","2086","2087","2088","2089","2090","2091","2092","2093","2094",
        "2095","2096","2097","2099","2100","2101","2102","2103","2104","2105","2106","2107",
        "2108","2109","2110","2111","2112","2113","2114","2115","2116","2117","2118","2119",
        "2120","2121","2122","2123","2125","2126","2127","2128","2130","2131","2132","2133",
        "2134","2135","2136","2137","2138","2139","2140","2141","2142","2143","2144","2145",
        "2146","2147","2148","2150","2151","2152","2153","2154","2155","2160","2161","2162",
        "2163","2164","2165","2166","2168","2170","2171","2172","2173","2174","2175","2176",
        "2177","2178","2190","2191","2192","2193","2194","2195","2196","2197","2198","2199",
        "2200","2203","2204","2205","2206","2207","2208","2209","2210","2211","2212","2213",
        "2214","2216","2217","2218","2219","2220","2221","2222","2223","2224","2225","2226",
        "2227","2228","2229","2230","2231","2232","2233","2234","2747","2748","2749","2750",
        "2751","2759","2760","2761","2762","2763","2766","2767","2768","2769","2770","9997",
        "9998","9999"
      ],
      "days": "Saturday, Sunday, Tuesday, Wednesday",
      "dayLeadTimes": {
        "Saturday": 4, // cutoff Tuesday 2pm
        "Sunday": 5, // cutoff Tuesday 2pm
        "Tuesday": 5, // cutoff Thursday 2pm
        "Wednesday": 6 // cutoff Thursday 2pm
      }
    },
    {
      "region": "Syd Southwest",
      "postcodes": [
        "2167","2179","2557","2558","2559","2560","2563","2564","2565","2566","2567","2568",
        "2569","2570"
      ],
      "days": "Saturday, Sunday, Tuesday, Wednesday",
      "dayLeadTimes": {
        "Saturday": 4, // cutoff Tuesday 2pm
        "Sunday": 5, // cutoff Tuesday 2pm
        "Tuesday": 5, // cutoff Thursday 2pm
        "Wednesday": 6 // cutoff Thursday 2pm
      }
    },
    {
      "region": "Syd Regional",
      "postcodes": [
        "2077","2079","2080","2081","2082","2083","2156","2157","2158","2159","2555","2556",
        "2745","2752","2753","2754","2756","2757","2765","2773","2774","2775","2776","2777",
        "2778"
      ],
      "days": "Saturday"
    },
    {
      "region": "Newcastle",
      "postcodes": [
        "2267","2278","2280","2281","2282","2283","2284","2285","2286","2287","2289","2290",
        "2291","2292","2293","2294","2295","2296","2297","2298","2299","2300","2302","2303",
        "2304","2305","2306","2307","2308","2309"
      ],
      "days": "Sunday, Monday",
      "dayLeadTimes": {
        "Sunday": 5, // cutoff Tuesday 2pm
        "Monday": 6 // cutoff Tuesday 2pm
      }
    },
    {
      "region": "Mel Metro",
      "postcodes": [
        "3000","3001","3002","3003","3004","3005","3006","3008","3010","3011","3012","3013",
        "3015","3016","3018","3019","3020","3021","3022","3023","3024","3025","3026","3027",
        "3028","3029","3030","3031","3032","3033","3034","3036","3037","3038","3039","3040",
        "3041","3042","3043","3044","3045","3046","3047","3048","3049","3050","3051","3052",
        "3053","3054","3055","3056","3057","3058","3059","3060","3061","3065","3066","3067",
        "3068","3070","3071","3072","3073","3074","3075","3078","3079","3081","3082","3083",
        "3084","3085","3086","3087","3088","3089","3090","3093","3094","3095","3096","3101",
        "3102","3103","3104","3105","3106","3107","3108","3109","3111","3113","3114","3121",
        "3122","3123","3124","3125","3126","3127","3128","3129","3130","3131","3132","3133",
        "3134","3135","3136","3137","3140","3141","3142","3143","3144","3145","3146","3147",
        "3148","3149","3150","3151","3152","3153","3154","3155","3156","3161","3162","3163",
        "3164","3165","3166","3167","3168","3169","3170","3171","3172","3173","3174","3175",
        "3177","3178","3179","3180","3181","3182","3183","3184","3185","3186","3187","3188",
        "3189","3190","3191","3192","3193","3194","3195","3196","3197","3198","3199","3200",
        "3201","3202","3204","3205","3206","3207","3800","3802","3803","3804","3805","3806",
        "3807","3808","3809","3810","3910","3975","3976","3977","3978","3980"
      ],
      "days": "Sunday, Monday, Wednesday, Thursday",
      "dayLeadTimes": {
        "Sunday": 5, // cutoff Tuesday 2pm
        "Monday": 6, // cutoff Tuesday 2pm
        "Wednesday": 6, // cutoff Thursday 2pm
        "Thursday": 7 // cutoff Thursday 2pm
      }
    },
    {
      "region": "Geelong",
      "postcodes": [
        "3211","3212","3213","3214","3215","3216","3217","3218","3219","3220","3221","3222",
        "3223","3224","3225","3226","3227","3228","3230","3231","3232","3240","3321","3328",
        "3331","3332"
      ],
      "days": "Monday"
    },
    {
      "region": "Monrington Pensinsula / Central Highlands",
      "postcodes": [
        "3115","3116","3138","3139","3158","3159","3160","3335","3336","3337","3338","3340",
        "3341","3342","3428","3440","3458","3765","3766","3767","3770","3775","3777","3781",
        "3782","3783","3785","3786","3787","3788","3789","3791","3792","3793","3795","3796",
        "3797","3799","3911","3912","3913","3915","3916","3918","3919","3920","3926","3927",
        "3928","3929","3930","3931","3933","3934","3936","3937","3938","3939","3940","3941",
        "3942","3943","3944"
      ],
      "days": "Wednesday"
    },
    {
      "region": "BNW Metro",
      "postcodes": [
        "4000","4004","4005","4006","4007","4008","4009","4010","4011","4012","4013","4014",
        "4017","4018","4019","4020","4021","4022","4030","4031","4032","4034","4035","4036",
        "4037","4051","4053","4054","4055","4059","4060","4061","4064","4065","4066","4067",
        "4068","4069","4070","4072","4073","4074","4075","4076","4077","4078","4101","4102",
        "4103","4104","4105","4106","4107","4108","4109","4110","4111","4112","4113","4114",
        "4115","4116","4117","4118","4119","4120","4121","4122","4123","4124","4125","4127",
        "4128","4129","4130","4131","4132","4133","4151","4152","4153","4154","4155","4156",
        "4157","4158","4159","4160","4161","4163","4164","4165","4169","4170","4171","4172",
        "4173","4174","4178","4179","4300","4301","4303","4304","4305","4306","4500","4501",
        "4502","4503","4504","4505","4506","4508","4509"
      ],
      "days": "Sunday, Monday, Wednesday, Thursday",
      "dayLeadTimes": {
        "Sunday": 5, // cutoff Tuesday 2pm
        "Monday": 6, // cutoff Tuesday 2pm
        "Wednesday": 6, // cutoff Thursday 2pm
        "Thursday": 7 // cutoff Thursday 2pm
      }
    },
    {
      "region": "Gold Coast, Sunshine Coast, CBR Metro",
      "postcodes": [
        "2600","2601","2602","2603","2604","2605","2606","2607","2608","2609","2610","2611",
        "2612","2614","2615","2616","2617","2618","2619","2620","2900","2902","2903","2904",
        "2905","2906","2911","2912","2913","2914","4205","4207","4208","4209","4210","4211",
        "4212","4213","4214","4215","4216","4217","4218","4219","4220","4221","4223","4224",
        "4225","4226","4227","4228","4229","4230","4507","4510","4511","4516","4517","4518",
        "4519","4550","4551","4552","4553","4554","4555","4556","4557","4558","4559","4560",
        "4561","4562","4563","4564","4565","4566","4567","4572","4573","4574","4575"
      ],
      "days": "Sunday, Monday, Wednesday, Thursday",
      "dayLeadTimes": {
        "Sunday": 5, // cutoff Tuesday 2pm
        "Monday": 6, // cutoff Tuesday 2pm
        "Wednesday": 6, // cutoff Thursday 2pm
        "Thursday": 7 // cutoff Thursday 2pm
      }
    },
    {
      "region": "Adl Metro",
      "postcodes": [
        "5000","5006","5007","5008","5009","5010","5011","5012","5013","5014","5015","5016",
        "5017","5018","5019","5020","5021","5022","5023","5024","5025","5031","5032","5033",
        "5034","5035","5037","5038","5039","5040","5041","5042","5043","5044","5045","5046",
        "5047","5048","5049","5050","5051","5052","5061","5062","5063","5064","5065","5066",
        "5067","5068","5069","5070","5072","5073","5074","5075","5076","5081","5082","5083",
        "5084","5085","5086","5087","5088","5089","5090","5091","5092","5093","5094","5095",
        "5096","5097","5098","5106","5107","5108","5109","5110","5111","5112","5113","5114",
        "5115","5116","5117","5118","5120","5121","5125","5126","5127","5131","5132","5133",
        "5134","5136","5137","5138","5139","5140","5141","5142","5144","5150","5151","5152",
        "5153","5154","5155","5156","5157","5158","5159","5160","5161","5162","5163","5164",
        "5165","5166","5167","5168","5169","5170","5171","5172","5173","5174","5201","5202",
        "5203","5204","5210","5211","5212","5213","5214","5231","5232","5233","5234","5235",
        "5236","5237","5238","5240","5241","5242","5243","5244","5245","5250","5251","5252",
        "5253","5254","5255","5256","5350","5351","5352","5353","5355","5356","5360","5371",
        "5372","5373","5374","5400","5401","5410","5411","5412","5501","5502","5950"
      ],
      "days": "Tuesday"
    },
    {
      "region": "Wollongong",
      "postcodes": [
        "2500","2502","2505","2506","2508","2515","2516","2517","2518","2519","2520","2525",
        "2526","2527","2528","2529","2530","2533"
      ],
      "days": "Monday"
    },
    {
      "region": "Central Coast",
      "postcodes": ["2250","2251","2256","2257","2258","2259","2260","2261","2262","2263","2264","2265"],
      "days": "Tuesday"
    },
    {
      "region": "Southern Highlands",
      "postcodes": [
        "2315","2316","2317","2318","2319","2320","2321","2322","2323","2324","2326","2421",
        "2571","2572","2573","2574","2575","2576","2577","2578","2579"
      ],
      "days": "Monday"
    },
    {
      "region": "Toowoomba",
      "postcodes": [
        "4311","4340","4341","4342","4343","4344","4346","4347","4350","4352","4353","4354",
        "4358","4400","4655"
      ],
      "days": "Sunday"
    },
    {
      "region": "Blue Mountains",
      "postcodes": ["2758","2779","2780","2782","2783","2784","2785","2786"],
      "days": "Monday"
    },
    {
      "region": "Bathurst",
      "postcodes": ["2787","2791","2795","2799"],
      "days": "Wednesday"
    },
    {
      "region": "Orange / Taree",
      "postcodes": [
        "2312","2422","2423","2428","2429","2430","2671","2798","2800","2865","2866"
      ],
      "days": "Monday"
    },
    {
      "region": "Port Macquarie",
      "postcodes": ["2426","2427","2439","2443","2444","2445","2446"],
      "days": "Wednesday"
    },
    {
      "region": "Southcoast",
      "postcodes": ["2534","2535","2538","2539","2540","2541"],
      "days": "Tuesday"
    },
    {
      "region": "Singleton",
      "postcodes": [
        "2325","2327","2328","2329","2330","2333","2334","2335","2336","2337","2338","2339",
        "2340","2341","2342","2343","2344","2345","2346","2350","2352","2353","2355","2358",
        "2381"
      ],
      "days": "Monday"
    },
    {
      "region": "Coffs Harbour",
      "postcodes": [
        "2431","2440","2441","2447","2448","2449","2450","2452","2454","2456","2470","2471",
        "2472","2473","2474","2477","2478","2479","2480","2481","2482","2483","2484"
      ],
      "days": "Wednesday"
    },
    {
      "region": "Gippsland South",
      "postcodes": [
        "3871","3873","3922","3923","3925","3945","3946","3950","3951","3953","3954","3956",
        "3957","3958","3959","3960","3962","3964","3965","3966","3967","3971","3979","3981",
        "3984","3987","3988","3990","3991","3992","3995","3996"
      ],
      "days": "Tuesday"
    },
    {
      "region": "Dubbo",
      "postcodes": [
        "2820","2830","2831","3062","3063","3064","3076","3091","3097","3099","3233","3234",
        "3235","3236","3237","3238","3239","3241","3242","3243","3249","3250","3251","3254",
        "3260","3264","3265","3266","3267","3268","3269","3270","3271","3272","3273","3274",
        "3275","3276","3277","3278","3279","3280","3281","3282","3283","3284","3285","3286",
        "3287","3289","3293","3300","3301","3302","3303","3304","3305","3322","3323","3324",
        "3325","3329","3330","3333","3334","3345","3350","3351","3352","3355","3356","3357",
        "3358","3360","3363","3364","3370","3371","3427","3429","3430","3431","3432","3433",
        "3434","3437","3438","3441","3460","3461","3464","3465","3467","3658","3659","3750",
        "3751","3752","3753","3754","3755","3756","3757","3758","3759","3760","3761","3762",
        "3763","3764"
      ],
      "days": "Monday"
    },
    {
      "region": "Sunshine Coast 2",
      "postcodes": ["4568","4569","4570"],
      "days": "Tuesday"
    },
    {
      "region": "Southcoast Regional",
      "postcodes": [
        "2536","2537","2545","2546","2548","2549","2550","2551","4401","4403","4405","4410",
        "4413"
      ],
      "days": "Monday"
    },
    {
      "region": "Central East Queensland",
      "postcodes": ["4703"],
      "days": "Thursday"
    },
    {
      "region": "Cairns",
      "postcodes": ["4879","4852","4701"],
      "days": "Wednesday"
    }
  ];

// Utility map for converting day names to numeric (Sunday=0, Monday=1, etc.)
const dayNameToIndex = {
  "Sunday": 0,
  "Monday": 1,
  "Tuesday": 2,
  "Wednesday": 3,
  "Thursday": 4,
  "Friday": 5,
  "Saturday": 6
};

const deliveryDayMinIntervals = {
  0: 5, // Sunday
  1: 6, // Monday
  2: 7, // Tuesday
  3: 8, // Wednesday
  4: 9, // Thursday
  5: 3, // Friday
  6: 4 // Saturday
};

// Helper: Convert a Date to the day name string, e.g. "Monday"
function getDayName(date) {
  return date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    weekday: "long"
  });
}

// Helper: Return an English ordinal suffix for a given day of month: 1 -> "1st", 2 -> "2nd" etc.
function getDaySuffix(dayNum) {
  // “Teens” always get “th”
  if (dayNum >= 11 && dayNum <= 13) return "th";
  // Otherwise, last digit decides
  switch (dayNum % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
}

// Helper: Format date as "Monday, 24th March 2025"
function formatAESTDate(date) {
  const dayName   = getDayName(date); // e.g. "Monday"
  const dayNum    = date.toLocaleString("en-AU", { timeZone: "Australia/Sydney", day: "numeric" });
  const monthName = date.toLocaleString("en-AU", { timeZone: "Australia/Sydney", month: "long" });
  const year      = date.toLocaleString("en-AU", { timeZone: "Australia/Sydney", year: "numeric" });
  return `${dayName}, ${dayNum}${getDaySuffix(+dayNum)} ${monthName} ${year}`;
}

// Returns a Date object for "right now" in local JS time.
// If you truly must force it to AEST, you’ll need additional offset logic or a library.
function getAESTNow() {
  // Naive example: parse the local time as "Australia/Sydney". 
  // In real usage, ensure your server/JS environment is set to AEST or use a dedicated library.
  return new Date();
}

// Main function: Given an array of day names (e.g. ["Monday", "Tuesday"]), find the next 5 valid dates.
function getNextValidDates(daysArray, count = 5) {
  const now = getAESTNow();

  // Convert day names to numeric day-of-week indices
  const validDayIndices = daysArray.map(d => dayNameToIndex[d]);

  const results = [];
  let candidate = new Date(now);

  // We'll iterate forward until we find `count` valid matches (or until we reach some limit).
  // Start checking from "tomorrow" by default:
  candidate.setDate(candidate.getDate() + 1);

   while (results.length < count) {
      const candidateDayIndex = candidate.getDay();
      if (!validDayIndices.includes(candidateDayIndex)) {
        candidate.setDate(candidate.getDate() + 1);
        continue;
      }
  
      //const minInterval = deliveryDayMinIntervals[candidateDayIndex];
      // Try region-specific lead times first
      let minInterval;
      if (window.currentMatchedRegion && window.currentMatchedRegion.dayLeadTimes) {
        const dayName = getDayName(candidate);
        if (window.currentMatchedRegion.dayLeadTimes[dayName]) {
          minInterval = window.currentMatchedRegion.dayLeadTimes[dayName];
        }
      }

      // Fallback to global defaults
      if (!minInterval) {
        minInterval = deliveryDayMinIntervals[candidateDayIndex];
      }


      const cutoff = new Date(candidate);
      cutoff.setDate(candidate.getDate() - minInterval);
      cutoff.setHours(14, 0, 0, 0); // 2pm cutoff time


        // Add these lines here
        console.log("Checking delivery date:", candidate.toString());
        console.log("Now:", now.toString());
        console.log("Cutoff:", cutoff.toString());
     console.log("Min INterval:", minInterval);
     
      if (now <= cutoff) {
        results.push(new Date(candidate));
      }
  
      candidate.setDate(candidate.getDate() + 1);
    }

  return results;
}

// ----------------------------------------------
// 2) Wire up the button click
document.addEventListener('DOMContentLoaded', function() {
  const btnCheck  = document.querySelector('#cart_postcode_check');
  const inputPost = document.querySelector('#cart_postcode');

  if (!btnCheck || !inputPost) return;

  btnCheck.addEventListener('click', function() {

    document.querySelector('#cart_available_days').classList.add("active");
    
    const postcode = inputPost.value.trim();
    if (!postcode) {
        const labelEl = document.querySelector('#cart_available_days > label');
        if (labelEl) {
          labelEl.innerHTML = 'Please enter a valid postcode';
        }
        const ulEl = document.querySelector('#cart_available_days > ul');
        ulEl.innerHTML("");
      return;
    }

    // Find a region whose "postcodes" array includes our entered postcode
    const matchedRegion = deliveryData.find(r => r.postcodes.includes(postcode));
    if (!matchedRegion) {
        const labelEl = document.querySelector('#cart_available_days > label');
        if (labelEl) {
          labelEl.innerHTML = 'Unfortunately we do not currently deliver to your suburb.';
        }
        const ulEl = document.querySelector('#cart_available_days > ul');
        ulEl.innerHTML("");
      return;
    }

    // The region might have 1 or more days in a string (e.g. "Monday, Tuesday")
    // Convert that to an array of day names
    const daysArr = matchedRegion.days
      .split(',')
      .map(d => d.trim())
      .filter(Boolean);

    if (!daysArr.length) {
        const labelEl = document.querySelector('#cart_available_days > label');
        if (labelEl) {
          labelEl.innerHTML = 'Unfortunately we have no delivery dates for your area';
        }
        const ulEl = document.querySelector('#cart_available_days > ul');
        ulEl.innerHTML = '';
      return;
    }

    window.currentMatchedRegion = matchedRegion;

    // 3) Get next 5 valid dates:
    const nextFive = getNextValidDates(daysArr, 5);

    // 4) Display or log them:
    if (!nextFive.length) {
        const labelEl = document.querySelector('#cart_available_days > label');
        if (labelEl) {
          labelEl.innerHTML = 'Unfortunately we have no delivery dates for your area';
        }
        const ulEl = document.querySelector('#cart_available_days > ul');
        ulEl.innerHTML = '';
        return;
    }

    // Previously: alert(`Next 5 valid days:\n\n${formattedList.join('\n')}`);
    const formattedList = nextFive.map(d => formatAESTDate(d));
    
    // 1) Set the first date in the label
    const labelEl = document.querySelector('#cart_available_days > label');
    if (labelEl) {
      labelEl.textContent = formattedList[0]; 
      setDeliveryDateFromLabel();
    }
    
    // 2) List all five dates in a UL
    const ulEl = document.querySelector('#cart_available_days > ul');
    if (ulEl) {
      // Clear existing items if needed
      ulEl.innerHTML = '';
    
      formattedList.forEach(dateString => {
        const li = document.createElement('li');
        li.textContent = dateString;
        ulEl.appendChild(li);
      });

      const listItems = document.querySelectorAll('#cart_available_days ul li');
      listItems.forEach(function(li) {
        li.addEventListener('click', function() {
          // Replace the label's inner HTML with the clicked li's content
          if (labelEl) {
            labelEl.innerHTML = li.innerHTML;
            setDeliveryDateFromLabel();
          }
          ulEl.classList.remove('active');
        });
      });
      
    }
    
  });
});


//---- Convert for Cart Submission

function formatDateFromLabel(labelText) {
  // 1) Split by comma to separate "Saturday" from "22nd March 2025"
  const parts = labelText.split(',');
  if (parts.length < 2) {
    console.error('Unexpected date format:', labelText);
    return null;
  }

  // Trim the second part: "22nd March 2025"
  const datePart = parts[1].trim(); // "22nd March 2025"

  // 2) Split into [ "22nd", "March", "2025" ]
  const datePieces = datePart.split(' ');
  if (datePieces.length < 3) {
    console.error('Unexpected date format:', datePart);
    return null;
  }

  let [ dayStr, monthStr, yearStr ] = datePieces;

  // 3) Remove any non-digit characters from the day (handles "22nd", "31st", "3rd", etc.)
  dayStr = dayStr.replace(/\D/g, ''); // e.g. "22nd" -> "22"

  // Convert day to a 2-digit string (e.g. "1" -> "01")
  const day = dayStr.padStart(2, '0');

  // 4) Convert the month name to a two-digit month
  const months = {
    january: '01',   february: '02',  march: '03',
    april: '04',     may: '05',       june: '06',
    july: '07',      august: '08',    september: '09',
    october: '10',   november: '11',  december: '12'
  };

  const monthLower = monthStr.toLowerCase();
  const month = months[monthLower] || '01'; // default to '01' if not found

  // 5) Year is assumed to be correct as-is
  const year = yearStr;

  // 6) Format the final string as dd/mm/yyyy
  return `${day}/${month}/${year}`;
}